const UTILS = {
  GetOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  },
  OnMutate(targetNodes, callback) {
    var observer = new MutationObserver(callback);

    // Notify me of everything!
    var observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true
    };

    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  },
  ConvertStringToHTML(str) {
    return new DOMParser().parseFromString(str, 'text/html');
  }  
};

document.addEventListener('alpine:init', () => {
  Alpine.data('MM_ImageCards', () => ({
    menu: '',
    init() {
      let am = this;
      am.InitSelf()
      am.Render()
    },
    InitSelf() {
      let am = this;
      am.menu = am.$el.dataset.menu
    },
    Render() {
      let am = this;
      document.querySelectorAll(`.megamenu__images[data-menu="${am.menu}"]`).forEach(($section) => {
        if ($section.classList.contains('cards-rendered')) return;
        $section.insertAdjacentHTML('beforeend', am.$el.querySelector('.megamenu__images').innerHTML)
        $section.classList.add('cards-rendered')
      })
    }
  }));

  Alpine.data('StickyFiltersToggle', () => ({
    cache: {},
    flags: {
      active: false
    },
    init() {
      let am = this;
      am.$nextTick(am.InitSelf.bind(am))

      am.$watch('flags.active', () => {
        am.$nextTick(() => {
          am.cache.$sidebar.classList.toggle('is-active', am.flags.active)
          am.cache.$btn_toggle.classList.toggle('is-active', am.flags.active)  
          console.log(am.cache)
        })
      })
    },
    InitSelf() {
      let am = this;
      am.cache.$btn_toggle = am.$el
      am.cache.$filterBar = am.$el.closest('.collection-filter')
      am.cache.$sidebar = document.querySelector('.grid__item--sidebar')
      am.cache.$btn_closeFilters = document.querySelector('.btn-close-filters')
      if (am.cache.$btn_closeFilters) {
        am.cache.$btn_closeFilters.addEventListener('click', am.CloseFilter.bind(am))
      }

      let btn_offset = UTILS.GetOffset(am.cache.$btn_toggle)
      am.cache.$sidebar.style.setProperty('--filter-active-top', `${am.cache.$filterBar.style.top}`)
      am.cache.$sidebar.style.setProperty('--filter-active-left', `${btn_offset.left}px`)
    },
    e_OpenFilter(e) {
      this.OpenFilter();
    },
    OpenFilter() {
      this.flags.active = true
    },
    CloseFilter() {
      this.flags.active = false
    }
  }));

  Alpine.data('ReadMoreToggle', () => ({
    cache: {},
    init() {
      this.InitSelf()
    },
    InitSelf() {
      let am = this;
      am.$el.classList.add('readmore-enabled')
      am.$el.insertAdjacentHTML('beforeend', '<span class="toggle_Readmore" @click="e_ToggleReadmore">Read more</span>')
    },
    e_ToggleReadmore(e) {
      // console.log(e)
      let $target = e.currentTarget;
      let $readmore  = $target.closest('[data-readmore]')
      $readmore.classList.toggle('is_active')
      let is_active = $readmore.classList.contains('is_active')
      $target.innerText = is_active ? 'Read less' : 'Read more'
    }
  }));


  Alpine.data('ProductInfo', () => ({
    cache: {},
    flags: {
      is_enquire: false
    },
    product: null,
    init() {
      this.InitCache();
      this.InitSelf();
      this.UpdateFlags();
    },
    InitCache() {
      let am = this;
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.$el.dataset.product);
    },
    UpdateFlags() {
      let am = this;
      am.flags.is_enquire = am.product.tags.indexOf('inquire-only') !== -1;
    }
  }));

  Alpine.data('ContactFormProduct', () => ({
    product_title: '',
    product_url: '',
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      let url_params = new URLSearchParams(window.location.search);
      am.product_title = url_params.get('product_title');
      am.product_url = url_params.get('product_url');
    }
  }));
});